<!--
 * @Description: 标准直播播放
 * @Date: 2021-11-04 11:02:45
 * @LastEditTime: 2022-02-18 21:10:30
-->
<template>
  <div class="cdn-stream" ref="videoWarp">
    <!-- 未开播、预告 不显示 -->
    <video
      class="stream"
      id="cdn-video-container"
      playsinline="playsinline"
      webkit-playsinline="webkit-playsinline"
    ></video>

    <img
      v-if="coverImages[0] && coverImages[0].url ? true : false"
      v-show="isActive === 0 || isActive === 3"
      class="posterImg"
      :src="coverImages[0].url"
    />

    <div class="loading" v-show="showLoading"></div>
  </div>
</template>

<script>
import { PLAY_STATE } from '@/constants/room';
import { UPDATE_PLAY_STATE } from '@/constants/mutation-types';
import { isAndroid, isMicroMessenger } from '@/utils/utils';
import { mapState } from 'vuex';
export default {
  name: 'compCdnStream',
  data() {
    return {
      player: null,
      isPlaying: false
    };
  },
  computed: {
    ...mapState({
      sdkAppId: state => state.player.sdkAppId,
      // isActive: state => state.player.isActive,
      playerDomain: state => state.player.playerDomain,
      playState: state => state.player.playState,
      playUrl: state => state.player.playUrl,
      liveInfo: state => state.player.liveInfo,
      // roomId: state => state.player.roomId,

      coverImages: (state) => {
        if (
          state?.player?.liveInfo?.coverImages
          && state.player.liveInfo.coverImages.length > 0
        ) {
          // console.log(state.player.liveInfo.coverImages)
          return state.player.liveInfo.coverImages

          // return [{
          //   url: 'http://202.105.45.203:9080/storage/group1/M00/09/D0/CrEEwmRu20KAYPjOAABcJJG7czA776.jpg',
          //   name: '测试图片6.jpg',
          //   uid: 1684987306253,
          // }]
        }
        return []
      },

      isActive(state) {
        const _isActive = state.player.isActive;
        try {
          const $dom = document.querySelector('#cdn-video-container.stream');
          if ($dom) {
            $dom.style.display = _isActive === 0 || _isActive === 3 || _isActive === -99 ? 'none' : 'inline-block';
          }
        } catch (e) {

        }
        return _isActive;
      },
    }),
    showLoading() {
      return !!this.playUrl &&  this.playState === PLAY_STATE.PLAYING && !this.isPlaying;
    },
  },
  watch: {
    playState(val) {
      if (val === PLAY_STATE.PLAYING) {
        this.player && this.player.play();
      } else if (val === PLAY_STATE.PAUSED) {
        this.player && this.player.pause();
      }
    },
    playUrl: {
      immediate: true,
      handler() {
        // if (this.playUrl && !this.player) {
        // } else {
        // console.error('没有直播地址');
        // }

        if (this.player) {
          if (this.playUrl) {

          } else {  // 突然没直播地址，就销毁直播
            this.destroyPlayer(true)
          }
        } else {
          if (this.playUrl) {
            this.$nextTick(() => {
              this.initPlayer();
            })
          } else {
            console.error('有直播实例，没直播地址');
          }
        }
      },
    },
  },
  methods: {
    initPlayer() {
      console.warn('初始化 m3u8直播', this.playUrl);

      const posterUrl = this.coverImages[0] ? this.coverImages[0].url : '';

      // eslint-disable-next-line no-undef
      this.player = TCPlayer('cdn-video-container', {
        controls: true,
        autoplay: this.playState === PLAY_STATE.PLAYING,
        poster: posterUrl,
        coverpic: {
          style: 'cover',
          src: posterUrl
        },
        wording: {
          // 1001: '开始拉流',
          2: '摄像头连接网络不稳定',
          1002: '即将直播，请稍等',
          2032: '请求视频失败，请检查网络',
          2048: '请求m3u8文件失败，可能是网络错误或者跨域问题'
        },
        x5_type: this.$isMobile ? 'h5' : '',
        // x5_player: !!this.$isMobile,
        x5_player: false,
      });
      // this.player.src(`https://${this.playerDomain}/live/${this.roomId}.m3u8`);
      this.player.src(this.playUrl);
      // this.player.src('rtmp://play-nf.southcn.com/nfwlive/project_2130_hd');
      this.playerListener();

      this.$nextTick(() => {
        this.player.play();
      });
    },
    playerListener() {
      this.player.on('error', (err) => {
        const { type, data } = err;

        if (type === 'error') {
          console.log('未知错误', data)

          this.isPlaying = false;

          setTimeout(() => {
            this.player.load();
          }, 3000);
        }
      });
      this.player.on('playing', () => {
        this.isPlaying = true;
      });
    },
    destroyPlayer(flag) {
      this.player && this.player.dispose();
      this.player = null;
      if (flag) {
      // dispose 后 dom 会消失，重新创建一个video dom
        this.$nextTick(() => {
          this.newVideo();
        })
      }
    },

    newVideo() {
      const $parent = this.$refs.videoWarp
      if (!$parent) {
        return false
      }
      const $video = document.createElement('video')
      $video.setAttribute('playsinline', 'playsinline');
      $video.setAttribute('webkit-playsinline', 'webkit-playsinline');
      $video.setAttribute('id', 'cdn-video-container');
      $video.className = 'stream';
      $video.style.display = this.isActive === 0 || this.isActive === 3 || this.isActive === -99 ? 'none' : 'inline-block';
      $parent.prepend($video);
    }
  },
  created() {
    // Andriod 微信中 TCPlayer 自动播放会失败，需要手动点击播放
    if (isAndroid && isMicroMessenger) {
      this.$store.commit(`player/${UPDATE_PLAY_STATE}`, 'paused');
    }
  },
  mounted() {
    // if (this.playerDomain === '') {
    //   console.error(`${this.$t('basic.Please configure your playerDomain')}\r\n\r\nconfig/basic-info-config.js`);
    //   return;
    // }

    // if (!this.playUrl) {
    //   console.error('没有直播地址');
    //   return false;
    // }
    // this.initPlayer();
  },
  beforeDestroy() {
    this.destroyPlayer(false);
  },
};
</script>

<style>
.stream {
  width: 100%;
  height: 100%;
}

</style>

<style lang="stylus" scoped>
.cdn-stream
  width 100%
  height 100%
  .posterImg
    width 100%
    height 100%
    object-fit contain
  .stream
    width 100%
    height 100%
  .loading
    position absolute
    top 0
    left 0
    width 100%
    height 100%
    background-color #000000
    display flex
    &:before
        content "loading..."
        display block
        color #ffffff
        font-size 24px
        width 100px
        height 30px
        line-height 30px
        position absolute
        top 50%
        left 50%
        transform translate(-50%, -50%)
</style>
